<template>
  <div class="bg-canicross">
    <div class="container pb-5">
      <div class="row justify-content-center">
        <div class="col-md-8">

          <h1 class="text-xhidenxi h4 mb-1">ELIGE TU RETO</h1>
          <div class="card card-form p-2 mb-4">
            <div class="btn-group w-100" role="group">
              <input type="radio" class="btn-check" name="tipoCarrera" id="btnCanicross" v-model="form.tipoCarrera"
                value="canicross">
              <label class="btn btn-outline-dark border-0 py-3 fw-bold" for="btnCanicross">Encuesta <br>🐾 CANICROSS (5KM)</label>

              <input type="radio" class="btn-check" name="tipoCarrera" id="btnSenderos" v-model="form.tipoCarrera"
                value="senderos">
              <label class="btn btn-outline-dark border-0 py-3 fw-bold" for="btnSenderos">Encuesta <br> ⛰️ SENDEROS (5KM)</label>
            </div>
          </div>

          <div v-if="form.tipoCarrera !== ''" class="card card-form p-4">
            <div class="text-center mb-4">
              <h1 class="text-xhidenxi h4 mb-1">XHIDENXI</h1>
              <p class="small">RETO ENTRE SENDEROS</p>
              <h2 class="display-5 fw-bold text-dark mb-0">
                {{ form.tipoCarrera === 'canicross' ? 'canicross🐾' : 'carrera 5km' }}
              </h2>
              <p class="text-muted small">ELIGE TU RETO | CANALEJAS 2026</p>
            </div>

            <form @submit.prevent="handleSubmit" novalidate :class="{ 'was-validated': validated }">

              <h5 class="section-title">Datos del Participante</h5>
              <div class="row g-3 mb-4">

                <!-- Seccion nombre -->
                <div class="col-md-9">
                  <label class="form-label small fw-bold">Nombre completo</label>
                  <input v-model="form.nombre" type="text" class="form-control" placeholder="Ej. Juan Pérez" required>
                  <div class="invalid-feedback">Por favor, ingresa el nombre.</div>
                </div>

                <!-- Seccion edad -->
                <div class="col-md-3">
                  <label class="form-label small fw-bold">Edad</label>
                  <input v-model="form.edad" type="text" class="form-control" placeholder="Ej. 25"
                    @input="form.edad = form.edad.replace(/\D/g, '').slice(0, 2)" required>
                </div>

                <!-- Seccion teléfono -->
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Teléfono</label>
                  <input v-model="form.telefono" type="tel" class="form-control" placeholder="Ej. 5555555555"
                    @input="form.telefono = form.telefono.replace(/\D/g, '').slice(0, 10)" required>
                  <div class="invalid-feedback">Debe contener 10 dígitos numéricos.</div>
                </div>

                <!-- Seccion correo -->
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Correo electrónico</label>
                  <input v-model="form.email" type="email" class="form-control" placeholder="Ej. juan@perez.com" required>
                </div>

                <!-- Seccion género -->
                <div class="col-12">
                  <label class="form-label small fw-bold">Género:</label>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="genero" id="radioM" value="Mujer"
                      v-model="form.genero" required>
                    <label class="form-check-label" for="radioM">
                      Mujer
                    </label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="genero" id="radioH" value="Hombre"
                      v-model="form.genero" required>
                    <label class="form-check-label" for="radioH">
                      Hombre
                    </label>
                  </div>

                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="genero" id="radioO" value="Otro"
                      v-model="form.genero" required>
                    <label class="form-check-label" for="radioO">Otro</label>
                  </div>

                  <!-- Input para género Otro -->
                  <div v-if="form.genero == 'Otro'" class="mt-2">
                    <input type="text" class="form-control" placeholder="Escríbelo aqui (Opcional)"
                      v-model="otroGenero">
                  </div>

                  <!-- Mensaje de error género -->
                  <div class="invalid-feedback d-block" v-if="validated && !form.genero">
                    Por favor selecciona un género.
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label small fw-bold">Talla de camiseta:</label>

                  <select class="form-select" v-model="form.tallaCamisa" required>
                    <option selected disabled value="">Selecciona una talla</option>
                    <option value="XS">XS (Extra Chica)</option>
                    <option value="S">S (Chica)</option>
                    <option value="M">M (Mediana)</option>
                    <option value="L">L (Grande)</option>
                    <option value="XL">XL (Extra Grande)</option>
                  </select>

                  <!-- Mensaje de error talla de playera -->
                  <div class="invalid-feedback d-block" v-if="validated && !form.tallaCamisa">
                    Por favor selecciona una talla.
                  </div>
                </div>

                <div class="col-12">
                  <label class="form-label small fw-bold">Localidad, Municipio y Estado</label>
                  <input v-model="form.ubicacion" type="text" class="form-control" placeholder="Ciudad de origen"
                    required>
                </div>
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Nombre contacto de emergencia</label>
                  <input v-model="form.contactoEmergenciaNombre" type="text" class="form-control">
                </div>
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Teléfono de emergencia</label>
                  <input v-model="form.contactoEmergenciaTel" type="tel" class="form-control">
                </div>
              </div>

              <!-- Seccion mascota -->
              <Transition name="fade">
                <div v-if="form.tipoCarrera === 'canicross'" class="mb-4">
                  <h5 class="section-title">Datos de tu Mejor Amigo 🐾</h5>
                  <div class="row g-3 mb-4">
                    <div class="col-md-5">
                      <label class="form-label small fw-bold">Nombre de la mascota</label>
                      <input v-model="form.mascota.nombre" type="text" class="form-control"
                        :required="form.tipoCarrera === 'canicross'">
                      <div class="invalid-feedback">Por favor, ingresa el nombre de tu amigo.</div>
                    </div>
                    <div class="col-md-3">
                      <label class="form-label small fw-bold">Edad</label>
                      <input v-model="form.mascota.edad" type="text" class="form-control" placeholder="Ej. 2 años"
                        :required="form.tipoCarrera === 'canicross'">
                    </div>
                    <div class="col-md-4">
                      <label class="form-label small fw-bold">Raza</label>
                      <input v-model="form.mascota.raza" type="text" class="form-control"
                        :required="form.tipoCarrera === 'canicross'">
                    </div>
                  </div>
                </div>
              </Transition>

              <div class="mb-4">
                <label class="form-label small fw-bold">¿Pertenecen a algún grupo de corredores? (Nombre y
                  Origen)</label>
                <textarea v-model="form.grupoCorredores" class="form-control" rows="2"></textarea>
              </div>

              <h5 class="section-title">Información de Pago</h5>

              <div class="row g-3 mb-4">
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Monto pagado</label>
                  <div class="input-group">
                    <span class="input-group-text">$</span>
                    <input v-model="form.monto" type="number" class="form-control" required>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="form-label small fw-bold">Fecha de pago</label>
                  <input v-model="form.fechaPago" type="date" class="form-control" required>
                </div>
                <div class="col-12">
                  <label class="form-label small fw-bold">Comprobante de pago</label>
                  <input type="file" @change="handleFile" ref="archivoInput" class="form-control" accept="image/*,.pdf"
                    required>
                </div>
              </div>

              <button type="submit" class="btn btn-canicross w-100 py-3 fw-bold shadow" :disabled="isLoading">
                <span v-if="!isLoading">
                  {{ form.tipoCarrera === 'canicross' ? 'INSCRIBIRME CON MI MASCOTA' : 'INSCRIBIRME A 5KM SENDEROS' }}
                </span>
                <span v-if="isLoading" class="spinner-border spinner-border-sm me-2"></span>
              </button>
            </form>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch, onMounted } from 'vue'
import { useToast } from 'vue-toast-notification'
import { db, storage } from '@/firebase/firebase'
import { collection, addDoc, serverTimestamp, updateDoc, doc, runTransaction } from 'firebase/firestore'
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage'
import imageCompression from 'browser-image-compression'
import router from '@/router'

const collectionName = 'corredores_canicross'
const counterCanicross = 'contador_corredores_canicross'
const storageFolder = 'comprobantes_canicross'

const $toast = useToast()

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

const form = reactive({
  tipoCarrera: '',
  nombre: '',
  edad: '',
  telefono: '',
  ubicacion: '',
  email: '',
  genero: '',
  tallaCamisa: '',
  contactoEmergenciaNombre: '',
  contactoEmergenciaTel: '',
  grupo: '',
  monto: '',
  fechaPago: '',
  // Objeto interno para mascota
  mascota: {
    nombre: '',
    edad: '',
    raza: ''
  }
})

const archivoComprobante = ref(null)
const archivoInput = ref(null)

const otroGenero = ref('')
const validated = ref(false)
const isLoading = ref(false)

const handleFile = (e) => {
  archivoComprobante.value = e.target.files[0]
}

const handleSubmit = async (event) => {
  validated.value = true
  const formData = event.target

  if (!formData.checkValidity()) {
    return
  }

  if (form.genero === 'Otro' && otroGenero.value.trim() !== '') {
    form.genero = otroGenero.value.trim()
  }

  try {
    isLoading.value = true

    // Asignación de número para corredor
    const numeroCorredor = await runTransaction(db, async (transaction) => {
      const contadorRef = doc(db, counterCanicross, 'contador')
      const contadorSnap = await transaction.get(contadorRef)
      let currentCount = 0

      if (!contadorSnap.exists()) {
        transaction.set(contadorRef, { contadorCompetidores: 1 })
      } else {
        currentCount = contadorSnap.data().contadorCompetidores
      }

      const newCount = currentCount + 1
      transaction.update(contadorRef, { contadorCompetidores: newCount })
      return newCount
    })

    // Si no es canicross, limpiamos los datos de mascota antes de enviar
    if (form.tipoCarrera !== 'canicross') {
      delete form.mascota
    }

    const docRef = await addDoc(collection(db, collectionName), {
      numCorredor: numeroCorredor,
      ...form,
      fechaRegistro: serverTimestamp(),
      comprobanteUrl: null,
      pagoConfirmado: false,
      pagoConfirmadoPor: null,
      fechaConfirmacionPago: null
    })

    if (archivoComprobante.value) {
      await subirComprobante(numeroCorredor, docRef.id, archivoComprobante)
    }

    Object.assign(form, {
      tipoCarrera: 'canicross',
      nombre: '',
      edad: '',
      telefono: '',
      ubicacion: '',
      email: '',
      genero: '',
      tallaCamisa: '',
      contactoEmergenciaNombre: '',
      contactoEmergenciaTel: '',
      grupo: '',
      monto: '',
      fechaPago: '',
      mascota: {
        nombre: '',
        edad: '',
        raza: ''
      }
    })

    archivoComprobante.value = null
    if (archivoInput.value) archivoInput.value.value = null

    router.push({
      name: 'Confirmación Registro',
      params: { numeroCorredor: String(numeroCorredor) }
    })

    window.scrollTo({ top: 0, behavior: 'smooth' })
  } catch (e) {
    $toast.error('Error al guardar el registro. Intenta de nuevo.', {
      position: 'top-right',
      duration: 5000
    })
  } finally {
    isLoading.value = false
    validated.value = false
  }
}

const subirComprobante = async (numCorredor, idDoc, archivoComprobante) => {
  // Validación preventiva
  if (!archivoComprobante.value) return

  try {
    const file = await comprimirImagen(archivoComprobante.value)
    const ext = file.name.split('.').pop()
    const safeName = `comprobante_${idDoc}_${numCorredor}.${ext}`

    const formatterNumCorredor = String(numCorredor).padStart(3, '0')
    const path = `${storageFolder}/CorredorNum_${formatterNumCorredor}/${safeName}`
    const refPath = storageRef(storage, path)

    await uploadBytes(refPath, file)

    const url = await getDownloadURL(refPath)

    await updateDoc(doc(db, collectionName, idDoc), {
      comprobanteUrl: url,
      comprobanteError: false
    })
  } catch (uploadError) {
    await updateDoc(doc(db, collectionName, idDoc), {
      comprobanteUrl: null,
      comprobanteError: true,
      errorSubidaComprobante: uploadError.message
    })

    $toast.warning(
      'El registro se guardó, pero hubo un error al subir el comprobante. Puedes intentar subirlo más tarde.',
      { position: 'top-right', duration: 8000 }
    )
  }
}

async function comprimirImagen (file) {
  if (!file || !file.type.includes('image')) return file

  const opciones = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1400,
    useWebWorker: true
  }

  return await imageCompression(file, opciones)
}

watch(() => form.genero, (nuevo) => {
  if (nuevo) validated.value = false
})
</script>

<style scoped>
.btn-check:checked+.btn-outline-dark {
  background-color: #000 !important;
  color: #fff !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.bg-canicross {
  background: linear-gradient(180deg, #e1f5d4 0%, #ffffff 100%);
  min-height: 100vh;
  padding: 2rem 0;
}

.card-form {
  border: none;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.text-xhidenxi {
  color: #000;
  font-weight: 800;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.btn-canicross {
    background-color: #000;
    color: #fff;
    border: none;
    border-radius: 14px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    transition: all 0.3s ease;
}

.btn-canicross:hover:not(:disabled) {
    background-color: #222;
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

.btn-canicross:disabled {
    background-color: #aaa;
    cursor: not-allowed;
}

.section-title {
  border-left: 5px solid #000;
  padding-left: 10px;
  margin-bottom: 1.5rem;
  font-weight: bold;
}

.invalid-feedback {
  display: none;
}

.was-validated :invalid~.invalid-feedback {
  display: block;
}
</style>
